import { FEATURE_MNG } from '@/api/apiModules'
export default {
  viewType: 'form',
  module: `${FEATURE_MNG}/relateTestCase`,
  params: null,
  extraParams: null,
  okAction: 'create',
  formatData(data) {
    data.featureId = this.extraParams?.featureId
    const relateTestCaseArr = data.relateTestCaseArr.map(item => {
      return item.id
    })
    data.testCaseIdList = relateTestCaseArr
    return data
  },
  view: {
    title: '关联用例',
    labelPosition: 'right',
    content: [
      {
        $id: 'relateTestCaseArr',
        label: '关联用例',
        $type: 'sky-relation-option',
        actions: {
          nativeOn: {
            click: 'featureRelationTestCase'
          }
        },
        $el: {
          multiple: true
        },
        rules: [{ notEmpty: '关联用例' }]
      }
    ]
  }
}
